import styles from './styles/Homepage.module.css';
import { useEffect, useRef, useState } from 'react';
import Navigation from '../components/Navigation';
import About from './About';
import Experience from './Experience';
import Projects from './Projects';
import Contact from './Contact';
import RefContainer from '../components/RefContainer';

const Homepage = () =>
{
    const [activeSection, setActiveSection] = useState('');

    const sectionRefs = {
        about: useRef(null),
        experience: useRef(null),
        projects: useRef(null),
        contact: useRef(null)
    };

    useEffect(() =>
    {
        const observers = {};
        const observerOptions = {
            root: null,
            rootMargin: "-50% 0px", // Triggers when section is in the middle of viewport
            threshold: 0
        };

        Object.entries(sectionRefs).forEach(([section, ref]) =>
        {
            observers[section] = new IntersectionObserver(
                (entries) =>
                {
                    entries.forEach((entry) =>
                    {
                        if (entry.isIntersecting)
                        {
                            setActiveSection(section);
                        }
                    });
                },
                observerOptions
            );

            if (ref.current)
            {
                observers[section].observe(ref.current);
            }
        });

        return () =>
        {
            Object.entries(observers).forEach(([section, observer]) =>
            {
                if (sectionRefs[section].current)
                {
                    observer.unobserve(sectionRefs[section].current);
                }
            });
        };
    }, );


    return (
        <div className={styles.body}>
            <Navigation sectionRefs={sectionRefs} activeSection={activeSection} />

            <div className={styles.mainContainer}>


                <RefContainer theRef={sectionRefs.about} id={'about'} text={'Full-stack & Mobile Apps Developer'}>
                    <About />
                </RefContainer>

                <RefContainer theRef={sectionRefs.experience} id={'experience'} text={'Experience'}>
                    <Experience />
                </RefContainer>

                <RefContainer theRef={sectionRefs.projects} id={'projects'} text={'Projects'}>
                    <Projects />
                </RefContainer>

                <RefContainer theRef={sectionRefs.contact} id={'contact'} text={'Contact'}>
                    <Contact />
                </RefContainer>

            </div>
        </div>
    )
}


export default Homepage;